<template>
  <BModal
    id="modal-tenant-detail"
    ref="modal-tenant-detail"
    hide-footer="hide-footer"
    size="lg"
  >
    <template slot="modal-title">
      {{ __('Atualizar dados') }}
    </template>
    <template slot="default">
      <form>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <label>{{ __('Nome da Empresa') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="name"
                  v-model="account.name"
                  :placeholder="__('Digite o nome da sua empresa')"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('name')"
                >{{ account.errors.get('name') }}</span>
              </div>
              <div class="col-md-6">
                <label>{{ __('CNPJ') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="document"
                  v-model="account.document"
                  :placeholder="__('Digite seu CNPJ')"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('document')"
                >{{ account.errors.get('document') }}</span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <label>{{ __('Responsável') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="contact"
                  v-model="account.contact"
                  :placeholder="__('Nome do responsável pela empresa')"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('contact')"
                >{{ account.errors.get('contact') }}</span>
              </div>
              <div class="col-md-6">
                <label>E-mail</label>
                <input
                  class="form-control"
                  type="email"
                  name="email"
                  v-model="account.email"
                  :placeholder="__('E-mail do responsável pela empresa')"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('email')"
                >{{ account.errors.get('email') }}</span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <label>{{ __('CPF do Responsável') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="contact_document"
                  v-model="account.contact_document"
                  :placeholder="__('CPF do responsável pela empresa')"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('contact_document')"
                >{{ account.errors.get('contact_document') }}</span>
              </div>
              <div class="col-md-6">
                <label>{{ __('Telefone') }}</label>
                <input
                  class="form-control"
                  type="text"
                  name="contact_phone"
                  v-model="account.contact_phone"
                  :placeholder="__('Telefone do responsável')"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('contact_phone')"
                >{{ account.errors.get('contact_phone') }}</span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label>CEP</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="account.address.postalcode"
                  :placeholder="__('Digite para pesquisar')"
                ><span
                  class="form-text"
                  v-show="account.errors.has('address.postalcode')"
                >{{ account.errors.get('address.postalcode') }}</span><span
                  class="text-warning"
                  v-if="postalCodeFail"
                >{{ __('CEP Não encontrado') }}.</span><i
                  class="fa fa-spin fa-circle-o-notch"
                  v-if="searching"
                />
              </div>
              <div class="col-md-8">
                <label>{{ __('Rua') }}</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="account.address.street"
                  :placeholder="__('Digite o CEP')"
                  :readonly="! postalCodeFail"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('address.street')"
                >{{ account.errors.get('address.street') }}</span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label>{{ __('Número') }}</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="account.address.number"
                  :placeholder="__('Número')"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('address.number')"
                >{{ account.errors.get('address.number') }}</span>
              </div>
              <div class="col-md-8">
                <label>{{ __('Complemento') }}</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="account.address.complement"
                  :placeholder="__('Complemento')"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('address.complement')"
                >{{ account.errors.get('address.complement') }}</span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label>{{ __('Bairro') }}</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="account.address.district"
                  :placeholder="__('Digite o CEP')"
                  :readonly="! postalCodeFail"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('address.district')"
                >{{ account.errors.get('address.district') }}</span>
              </div>
              <div class="col-md-4">
                <label>{{ __('Cidade') }}</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="account.address.city"
                  :placeholder="__('Digite o CEP')"
                  :readonly="! postalCodeFail"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('address.city')"
                >{{ account.errors.get('address.city') }}</span>
              </div>
              <div class="col-md-4">
                <label>{{ __('Estado') }}</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="account.address.state"
                  :placeholder="__('Digite o CEP')"
                  :readonly="! postalCodeFail"
                ><span
                  class="form-text text-danger"
                  v-show="account.errors.has('address.state')"
                >{{ account.errors.get('address.state') }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="account.terms"
                value="true"
              >
              <label class="form-check-label">{{ __('Eu aceito os') }}<a
                class="hyperlink"
                href="https://salesflowcrm.movidesk.com/kb/article/405957/termos-de-uso"
                target="_blank"
              > {{ __('termos de uso') }}</a>.</label><span
                class="form-text text-danger"
                v-show="account.errors.has('terms')"
              >{{ account.errors.get('terms') }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer default-modal-footer">
          <button
            class="btn btn-box-success"
            type="submit"
            @click.prevent="saveAccount()"
            :disabled="account.busy"
          >
            {{ __('Continuar') }}
          </button>
        </div>
      </form>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  mounted () {
    Bus.$on('tenantDetail', (tenant) => {
      this.open(tenant);
    });

    this.$root.$on('bv::modal::hide', (event, modalId) => {
      if (modalId == 'modal-tenant-detail') {
        Alert.error(this.__('Dados não atualizados.'));
      }
    });
  },

  data () {
    return {
      account: new BulldeskForm({
        address: {
          postalcode: {},
        },
      }),
      searching: false,
      postalCodeFail: false,
    };
  },

  watch: {
    'account.address.postalcode': function (postalcode) {
      if (postalcode.length !== 8) {
        return;
      }

      this.getAddressByApi(postalcode);
    },
  },

  methods: {
    open (tenant = {}) {
      this.account = new BulldeskForm(tenant);
      this.account.address = {
        postalcode: '',
        street: '',
        number: '',
        district: '',
        complement: '',
        city: '',
        state: '',
        ...this.account.address,
      };

      this.$refs['modal-tenant-detail'].show();
    },

    saveAccount () {
      this.account.busy = true;

      Http.put('/billing/account', this.account).then(() => {
        this.editing = false;

        window.location.reload();
      });
    },

    getAddressByApi (postalcode) {
      this.searching = true;

      this.$http.get(`/address/${postalcode}`)
        .then(({ data }) => {
          this.account.address.postalcode = data.postalcode;
          this.account.address.city = data.city;
          this.account.address.street = data.street;
          this.account.address.district = data.district;
          this.account.address.state = data.state;

          this.postalCodeFail = false;
        })
        .catch(() => {
          this.postalCodeFail = true;
        })
        .finally(() => {
          this.searching = false;
        });
    },
  },
};
</script>
